/**
 * Kind badge — renders a repo/service's KIND (the auto-derived runtime shape:
 * service | api | job | frontend | lib, or "unknown"). Read-only: the kind is
 * derived by the classifier, and the PRIMARY bucket (product line) is curated in
 * the Review center — there is no per-repo edit control any more.
 */
export function ClassificationBadge({ value }: { value: string }) {
  const v = value || 'unknown';
  return (
    <span className="badge" title={`kind: ${v}`}>
      {v === 'unknown' ? <span className="muted">unknown</span> : v}
    </span>
  );
}
